import React from 'react';
import PropTypes from 'prop-types';

const REQUIRED_FIELD_SYMBOL = '*';

function CustomTitleField(props) {
  const {
    id,
    title,
    required,
    className,
    style,
  } = props;

  return (
    <legend id={id} className={className} style={style}>
      {title}
      {required && <span className="required">{REQUIRED_FIELD_SYMBOL}</span>}
    </legend>
  );
}

CustomTitleField.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

CustomTitleField.defaultProps = {
  id: '',
  title: '',
  required: false,
  className: '',
  style: {},
};

export default CustomTitleField;
